import { useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Opens the Workbook's Apps again when a Run completes, so they show the new
 * Results. A Report keeps its filters: filtered feeds are read again too.
 */
export function useReopenAfterRuns(workbookId: string) {
  const queryClient = useQueryClient();
  const runs = useQuery(
    orpc.workbooks.runs.queryOptions({ input: { workbookId } }),
  );
  // Newest first: the latest completed Run, once the list has loaded.
  const latest = runs.data
    ? (runs.data.find((run) => run.status === 'completed')?.id ?? null)
    : undefined;
  const seen = useRef(latest);
  useEffect(() => {
    if (latest === undefined) return;
    const before = seen.current;
    seen.current = latest;
    if (before === undefined || before === latest) return;
    void queryClient.invalidateQueries({
      queryKey: orpc.apps.openReport.key(),
    });
    void queryClient.invalidateQueries({
      queryKey: orpc.apps.readReport.key(),
    });
  }, [latest, queryClient]);
}
